import {FC, JSX, ConstructorCallBack} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {coreStore} from '@gongxigames/framework/core/globals';

export type WhenResourcesLoadedProps = {
    graphics?: string[];
    audio?: string[];
    children: ConstructorCallBack;
};

/**
 * Executes a callback function when the specified
 * audio and graphics resource packs have been loaded.
 * The result of the callback can be any "JSX.Element"
 * which will be added as a child to the parent elements.
 * In other words, it will create and add components to the scene
 * when the resources are loaded.
 */
export const $WhenResourcesLoaded: FC<WhenResourcesLoadedProps> = (props) => {
    let callBack = props.children as ConstructorCallBack | undefined;
    let children: JSX.Element;

    return Store.computed(() => {
        const {graphics, audio} = props;
        const packages = coreStore.resources_loadedPackages.value;

        if (!callBack) {
            return children;
        }

        const isGraphicsLoaded = !graphics || graphics.every(item => packages.graphics.includes(item));
        const isAudioLoaded = !audio || audio.every(item => packages.graphics.includes(item));

        if (isGraphicsLoaded && isAudioLoaded && callBack) {
            children = callBack();
            callBack = undefined;

            return children;
        }
    });
};
